<template lang="pug">
  #appHeader.d-flex.align-items-center.justify-content-center.px-5
    i.fas.fa-chevron-left.fa-lg.icon-back(
      v-if="hasBackTool",
      @click="backHandler('icon')"
    )
    b-img.h-100(
      fluid,
      :src="logoImg",
      alt="logo",
      v-if="headerType === 'logo'"
      @click="backHandler('logo')"
      style='max-height: 100%'
    )
    h4.mb-0(
      v-if="headerType === 'title'"
    ) {{ title }}
</template>

<script>
const brandName = `${process.env.VUE_APP_BRAND_NAME}`;
import defaultLogoUrl from '@/assets/images/logo/logo.png';

export default {
  name: 'appHeader',
  props: {
    hasBackTool: {
      type: Boolean,
      default: false
    },
    headerType: {
      type: String,
      default: 'logo'
    },
    title: {
      type: String,
      default: null
    },
    targetRouterName: {
      type: String,
      default: null
    },
    targetRouterParams: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      defaultLogo: `this.src="${defaultLogoUrl}"`,
      logoImg: defaultLogoUrl
    };
  },
  methods: {
    backHandler(type) {
      const vm = this;
      // icon 回上一頁 logo 回工作管理頁
      if (type === 'icon') {
        vm.$router.go(-1);
      } else {
        if (vm.targetRouterName) {
          const targetInfo = {
            name: vm.targetRouterName,
            params: vm.targetRouterParams
          };
          if (!vm.targetRouterParams) {
            delete targetInfo.params;
          }
          vm.$router.push(targetInfo);
        }
      }
    },
    changeImage() {
      const vm = this;
      try {
        vm.logoImg = require(`@/assets/images/logo/${brandName}.jpg`);
      } catch (e) {
        vm.logoImg = defaultLogoUrl;
      }
    },
  },
  mounted() {
    const vm = this;
    vm.changeImage();
  }
};
</script>
